// extracted by mini-css-extract-plugin
export default {"style":"main-module--style--x4Cxb"};